import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, map, startWith, Subject, takeUntil } from 'rxjs';
import { StoreService } from '../store/store.service';
import { timerFormat } from 'src/app/utils/utils';

@Injectable({
	providedIn: 'root',
})
export class TimerService {
	private stop$ = new Subject<void>();

	private expiredSubject$ = new BehaviorSubject<boolean>(false);
	readonly expiredOtp$ = this.expiredSubject$.asObservable();

	private remainingSecondsSubject$ = new BehaviorSubject<number | null>(null);
	readonly displayTime$ = this.remainingSecondsSubject$.pipe(
		map(seconds => {
			if (seconds === null) return null;
			return timerFormat(seconds);
		})
	);

	constructor(private readonly storeService: StoreService) {
		this.storeService.otp$.subscribe(otp => {
			if (otp?.secondsExpirationOtp && otp?.otpGenerationTime) {
				this.start(otp.secondsExpirationOtp, otp.otpGenerationTime);
			}
		});
	}

	private start(otpValiditySeconds: number, generationTime: string): void {
		this.stop();
		this.expiredSubject$.next(false);

		const generationOtpMs = new Date(generationTime).getTime();
		const expirationOtpMs = generationOtpMs + otpValiditySeconds * 1000;

		interval(1000)
			.pipe(
				startWith(0),
				map(() => Math.floor((expirationOtpMs - Date.now()) / 1000)),
				takeUntil(this.stop$)
			)
			.subscribe(remaining => {
				if (remaining > 0) {
					this.remainingSecondsSubject$.next(remaining);
				} else {
					this.remainingSecondsSubject$.next(0);
					this.expiredSubject$.next(true);
					this.stop();
				}
			});
	}

	stop(): void {
		this.stop$.next();
	}

	clear() {
		this.remainingSecondsSubject$.next(null);
		this.expiredSubject$.next(false);
		this.stop();
	}
}
